import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Event, NavigationEnd, NavigationStart, Router} from "@angular/router";
import {EstudioService} from "../estudio.service";
import {DynamicBarService} from "../../../_components/dynamic-bar/dynamic-bar.service";

@Component({
    templateUrl: 'familia-hijo.component.html',
    standalone: false,
    styleUrls: ['familia-hijo.component.scss']

})

export class FamiliaHijoComponent implements OnInit {

    alumno: any;
    isUnidad: boolean = false;

    public userImage: boolean = false;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private estudioService: EstudioService,
                private dynamicBarService: DynamicBarService) {
    }

    ngOnInit() {
        const hijoID = this.route.snapshot.paramMap.get('hijoID');

        this.route.params.subscribe((params: { hijoID }) => {
            this.alumno = undefined;
            this.userImage = false;
            this.cargarHijo(params.hijoID);
        });

        this.router.events.subscribe((event: Event) => {
            if (event instanceof NavigationEnd) {
                // Hide loading indicator
                this.isUnidad = this.router.url.toLowerCase().indexOf('unidad') > -1;
            }
        });
        this.isUnidad = this.router.url.toLowerCase().indexOf('unidad') > -1;

        this.cargarHijo(hijoID);
    }

    cargarHijo(hijoID) {
        this.estudioService.getHijo(hijoID).subscribe((res) => {
            this.alumno = res['alumno'];
            this.alumno['curso'] = res['curso'];
            let objImg = new Image(),
                that = this;
            objImg.src = this.alumno['imageUrl'];
            objImg.onload = function () {
                that.userImage = true;
            }
            this.dynamicBarService.setBarra('familia-hijo', {alumno: this.alumno});
        });
    }
}
